(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roomroot-product-worlds"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.documentElement;const cards=document.querySelectorAll('[data-world-mode]');const preview=(card)=>{root.dataset.roomrootWorld=card.dataset.worldMode;};const clear=(card)=>{if(root.dataset.roomrootWorld===card.dataset.worldMode){delete root.dataset.roomrootWorld;}};cards.forEach((card)=>{card.addEventListener('mouseenter',()=>preview(card));card.addEventListener('focus',()=>preview(card));card.addEventListener('mouseleave',()=>clear(card));card.addEventListener('blur',()=>clear(card));});})();

  } catch(e) { console.error(e); }
})();
})();
